import { RequestsProvider } from 'Context';
import { FileUpload } from '../FileUpload';

interface IUploadFiles {
  parentId: number | null;
  subId: number;
  clearSubCategory: () => void;
  handleSuccess: () => void;
  resetRequest: () => void;
  titleLabel: string;
  onlineFormLink?: string;
  onlineFormLinkPrefixText?: string;
  onlineFormLinkText?: string;
}

export const UploadFiles = ({
  parentId,
  subId,
  clearSubCategory,
  handleSuccess,
  resetRequest,
  titleLabel,
  onlineFormLink,
  onlineFormLinkPrefixText,
  onlineFormLinkText,
}: IUploadFiles) => {
  return (
    <>
      <RequestsProvider>
        <FileUpload
          parentId={parentId}
          subId={subId}
          goBack={clearSubCategory}
          handleSuccess={handleSuccess}
          resetRequest={resetRequest}
          titleLabel={titleLabel}
          onlineFormLink={onlineFormLink}
          onlineFormLinkPrefixText={onlineFormLinkPrefixText}
          onlineFormLinkText={onlineFormLinkText}
        />
      </RequestsProvider>
    </>
  );
};
